import { Pipe, PipeTransform } from "@angular/core";
import { ActionDto, ChanceNodeActionDto } from "@api";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: "actionDescription" })
export class ActionDescriptionPipe implements PipeTransform {
  constructor(private i18n: TranslateService) {}

  public transform(chanceNodeAction: ChanceNodeActionDto, action: ActionDto): string {
    switch (action.name) {
      case "UPDATE_ACTION_BUTTON":
        const value = (chanceNodeAction?.parameters as any)?.type;
        if (value) return this.i18n.instant(`ACTIONS.LABEL.UPDATE_ACTION_BUTTON.${value}`);
        break;

      case "SEND_WEBHOOK":
        return (chanceNodeAction?.parameters as any)?.httpMethod;

      default:
        return action.description || "";
    }
  }
}
